import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import { connect} from 'react-redux';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { pauseCampaign, runCampaign, unsubscribeCampaign } from '../../redux/contactApi';
import Utils from '../../Helpers/Utils';
import { campaignPause, campaignStart } from '../../redux/contactAction';
import Helper from '../../Helpers/Helper';
import CustomMenuPype from '../../common/custom-menu/CustomMenuPype';
import Styles from './new-style.module.css'
import NewConfirmAlert from "../../common/new-alert/NewConfirmAlert";
import { Button } from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PauseIcon from "@material-ui/icons/Pause";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import CampaignActionNoticeBoard from './modal/CampaignActionNoticeBoard';
import { AGENCY_BUSINESS_TYPE } from '../../../../helpers/CoreConstant';
import PermissionDeniedModal from '../../../common/PermissionDinedModal/PermissionDeniedModal';

const pauseContactArr = [2, 4, 7, 8, 9, 10];
const runningCampaignOptions = [{ id: 'pause', name: 'pause' }, { id: 'unsubscribe', name: 'unsubscribe' }]
const pauseCampaignOptions = [{ id: 'start', name: 'start' }, { id: 'unsubscribe', name: 'unsubscribe' }]
const completeCampaignOptions = [{ id: 'unsubscribe', name: 'unsubscribe' }]

const Campaign = (props) => {
    const [openPermissionDeniedModal, setOpenPermissionDeniedModal] = useState(false);
    const [permissionDeniedMessge, setOpenPermissionDeniedMessge] = useState('');
    const GLOBAL_PRIVCY_LEVEL = "GLOBAL";
    const isUserOwnerOrAdmin = Utils.getAccountData("userIsOwner") || Utils.getAccountData("userIsAdmin");
    const hasGlobalFeaturePermission = Utils.getAccountData("agencyBusinessType") === AGENCY_BUSINESS_TYPE.INSURANCE || Utils.getAccountData("hasGlobalFeature");
    const campaignIsPaused = (campaignId) => {
        if ((Utils.getAccountData('userId') === parseInt(props.data?.campaign?.user_id)|| 
            (hasGlobalFeaturePermission && isUserOwnerOrAdmin))) {
            confirmAlert({
                title: 'Campaign is paused',
                message: 'Run the campaign to add contact',
                buttons: [
                    {
                        label: 'ok',
                        onClick: () => {
                            let data = {
                                campaignId : props.data?.campaign?.id,
                                campaign_id : props.data?.campaign?.id,
                                prevent_previous_followup: 0,
                                sent_immediate_after_resume: 1
                            }
                            data = {...data}
                            props.campaignStart(data, (response) => {
                                if (response.data.status === "error"){
                                    window.showNotification('ERROR',response.data.html);
                                } else if(response.data.status === "success"){
                                    window.showNotification('SUCCESS','Campaign will start in a while')

                                    confirmAlert({
                                        childrenElement: () => {
                                          return (
                                              <CampaignActionNoticeBoard
                                                title = 'Your contact will be started shortly.'
                                                message = 'It could take up to 5 minutes.'
                                              />
                                          );
                                        },
                                        buttons: [
                                          {
                                            label: "Close",
                                            onClick: () => {
                                              return;
                                            },
                                            className: "button-modify",
                                          },
                                        ],
                                        overlayClassName: "alert-button-modify",
                                    });
                                }
                            })
                        }
                    },
                    {
                        label: 'cancel',
                        onClick: () => {
                            return;
                        }
                    }
                ]
            });
        } else {
            if(props.data?.campaign?.privacy_level === GLOBAL_PRIVCY_LEVEL){
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge("This contact has been added to the campaign by another user.")

            } else{
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge('You are not allow to do this as you are not owner of this campaign.')
            }; 
        }
    }

    const toStart = () => {

        if ((Utils.getAccountData('userId') === parseInt(props.data?.campaign?.user_id)) || (hasGlobalFeaturePermission &&  isUserOwnerOrAdmin)) {
            NewConfirmAlert({
                onSubmit : () => {
                    runCampaign({
                        contact_id: props.contact_id,
                        campaign_id: props.data?.campaign?.id
                    }).then(res => {
                        if(res.data){
                            window.showNotification('SUCCESS',"Contact will run in a while")

                            confirmAlert({
                                childrenElement: () => {
                                  return (
                                      <CampaignActionNoticeBoard
                                      title={"Your contact will be run shortly."}
                                      message = {"It could take up to 5 minutes."}
                                      />
                                  );
                                },
                                buttons: [
                                  {
                                    label: "Close",
                                    onClick: () => {
                                      return;
                                    },
                                    className: "button-modify",
                                  },
                                ],
                                overlayClassName: "alert-button-modify",
                              });
                        }else{
                            window.showNotification('ERROR',"Something went wrong")

                        }
                    });
                },
                title: 'Please confirm your selection below:',
                description: '',
                cancelText: 'Cancel',
                submitText: 'Run Campaign',
                width: '480px'
            });
        } else {
            if(props.data?.campaign?.privacy_level === GLOBAL_PRIVCY_LEVEL){
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge("This contact has been added to the campaign by another user.")

            } else{
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge('You are not allow to do this as you are not owner of this campaign.')
            }; 
        }

    }

    const toPause = () => {

        if ((Utils.getAccountData('userId') === parseInt(props.data?.campaign?.user_id)) || (hasGlobalFeaturePermission && isUserOwnerOrAdmin)) {

            NewConfirmAlert({
                onSubmit : () => {
                    pauseCampaign({
                        contact_id: props.contact_id,
                        campaign_id: props.data?.campaign?.id
                    }).then(res => {
                        if(res.data){
                            window.showNotification('SUCCESS',"Contact will pause in a while")
                            confirmAlert({
                                childrenElement: () => {
                                  return (
                                      <CampaignActionNoticeBoard
                                      title={"Your contact will be paused shortly."}
                                      message = {"It could take up to 5 minutes."}
                                      />
                                  );
                                },
                                buttons: [
                                  {
                                    label: "Close",
                                    onClick: () => {
                                      return;
                                    },
                                    className: "button-modify",
                                  },
                                ],
                                overlayClassName: "alert-button-modify",
                            });
                        }
                        else{
                            window.showNotification('ERROR',"Something went wrong")
                        }
                    });
                },
                title: 'Please confirm your selection below:',
                description: '',
                cancelText: 'Cancel',
                submitText: 'Pause Campaign',
                width: '480px'
            });
        } else {
            if(props.data?.campaign?.privacy_level === GLOBAL_PRIVCY_LEVEL){
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge("This contact has been added to the campaign by another user.")

            } else{
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge('You are not allow to do this as you are not owner of this campaign.')
            }; 
        }
    }

    const toUnsub = () => {

        if ((Utils.getAccountData('userId') === parseInt(props.data?.campaign?.user_id)) || (hasGlobalFeaturePermission && isUserOwnerOrAdmin)) {
            NewConfirmAlert({
                onSubmit : () => {
                    unsubscribeCampaign({
                        contact_id: props.contact_id,
                        campaign_id: props.data?.campaign?.id
                    }).then(res => {
                        if(res.data){
                            window.showNotification('SUCCESS',"Contact will unsubscribe in a while")

                        }else{
                            window.showNotification('ERROR',"Something went wrong")
                        }
                    });
                },
                title: 'Please confirm your selection below:',
                description: '',
                cancelText: 'Cancel',
                submitText: 'Unsubscribe',
                width: '480px'
            });

        } else {
            if(props.data?.campaign?.privacy_level === GLOBAL_PRIVCY_LEVEL){
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge("This contact has been added to the campaign by another user.")

            } else{
                setOpenPermissionDeniedModal(true);
                setOpenPermissionDeniedMessge('You are not allow to do this as you are not owner of this campaign.')
            }; 
        }
    }

    const onSubmit = (action) => {
        if (action === 'start') {
            toStart()
        } else if (action === 'pause') {
            toPause()
        } else if (action === 'unsubscribe') {
            toUnsub()
        }
    }

    let isRunning = false;
    let unsubscribe = false;
    let isPaused = false;
    let isComplete = false;
    let msg = '';

    if ((props.data?.subscription[0] && props.data?.subscription[0]?.is_unsubscribed === 1)) {
        isRunning = false;
        unsubscribe = true;
        msg = 'Unsubscribed';
    } else {
        if (props.data?.campaign != null) {
            if (props.data?.campaign?.status === 3) {


                if (props.data?.status === 1) {
                    isRunning = true;
                    msg = 'Running';
                } else if (pauseContactArr.includes(props.data?.status)) {

                    isRunning = false;
                    isPaused = true;
                    msg = 'Paused';
                } else if (props.data?.status === 6) {

                    isRunning = false;
                    isPaused = false;
                    isComplete= true
                    msg = 'Complete';
                }

            } else {
                isRunning = false;
                msg = 'Campaign Paused';
            }
        } else {
            isRunning = false;
            msg = 'Campaign Paused';
        }

    }

    const renderTriggerItemLabel = (flag='') => {
        if(flag==='isRunning'){
            return(
                <div className={Styles.runningLabelWrp}>
                    <i className={`material-icons ${Styles.leftIcon}`}>pause_arrow</i>
                    <span className={Styles.text}>{msg}</span>
                    <i className={`material-icons ${Styles.rightIcon}`}>expand_more</i>
                </div>
            );
        }
        else if(flag==='isPaused'){
            return(
                <div className={Styles.runningLabelWrp}>
                    <i className={`material-icons ${Styles.leftIcon}`}>play_arrow</i>
                    <span className={Styles.text}>{msg}</span>
                    <i className={`material-icons ${Styles.rightIcon}`}>expand_more</i>
                </div>
            );
        }
        else if(flag==='stop'){
            return(
                <div className={Styles.runningLabelWrp}>
                    <i className={`material-icons ${Styles.leftIcon}`}>stop</i>
                    <span className={Styles.text}>{msg}</span>
                    <i className={`material-icons ${Styles.rightIcon}`}>expand_more</i>
                </div>
            );
        }
        return ''
    }
    return (
        <>
        <div class="d-flex justify-content-between align-items-center v2_single__contact_campaign_item mb-3" >
            <Link to={`/campaign/details/${props.data?.campaign?.id}`} target="_blank">
                <h6 class=" cursor-pointer" style={{color: 'var(--gray)',fontSize:'14px'}}>{Helper.reduceTextLength(props.data?.campaign?.title,20)}</h6>
            </Link>

            {isRunning && (                
                <CustomMenuPype
                    popup={{
                        wrapperClass: Styles.popupWrapper,
                        placement: "left",
                        list: runningCampaignOptions,
                        renderList:(item, index, clickCallback) =>{
                            return (
                                <div className={`${Styles.itemWrp}`} key={index} onClick={clickCallback}>
                                    <span className={Styles.itemTitle}>{item.name}</span>
                                </div>
                            );
                        },
                        onClick: (item) => onSubmit(item.id),
                        height: "auto",
                        width: "auto",
                        listStyle: {
                            justifyContent: "left",
                        },
                    }}
                    label={{
                        renderCustom: renderTriggerItemLabel('isRunning'),
                    }}
                />

            )}
            {isPaused && (
                <CustomMenuPype
                    popup={{
                        wrapperClass: Styles.popupWrapper,
                        placement: "left",
                        list: pauseCampaignOptions,
                        renderList:(item, index, clickCallback) =>{
                            return (
                                <div className={`${Styles.itemWrp}`} key={index} onClick={clickCallback}>
                                    <span className={Styles.itemTitle}>{item.name}</span>
                                </div>
                            );
                        },
                        onClick: (item) => onSubmit(item.id),
                        height: "auto",
                        width: "auto",
                        listStyle: {
                            justifyContent: "left",
                        },
                    }}
                    label={{
                        renderCustom: renderTriggerItemLabel('isPaused'),
                    }}
                />
            )}
            {!isRunning && isComplete && !isPaused && (
                <CustomMenuPype
                    popup={{
                        wrapperClass: Styles.popupWrapper,
                        placement: "left",
                        list: completeCampaignOptions,
                        renderList:(item, index, clickCallback) =>{
                            return (
                                <div className={`${Styles.itemWrp}`} key={index} onClick={clickCallback}>
                                    <span className={Styles.itemTitle}>{item.name}</span>
                                </div>
                            );
                        },
                        onClick: (item) => onSubmit(item.id),
                        height: "auto",
                        width: "auto",
                        listStyle: {
                            justifyContent: "left",
                        },
                    }}
                    label={{
                        renderCustom: renderTriggerItemLabel('stop'),
                    }}
                />
            )}
            {!isRunning && !unsubscribe && !isPaused && !isComplete &&(
                // <div style={{background:'black'}} class="running_btn_campaigns d-flex align-items-center bg-green px-2" onClick={() => campaignIsPaused(props.data?.campaign_id)} >
                //     <i class="material-icons white-text">
                //         play_arrow
                //     </i>
                //     <span class="white-text mx-2">{msg}</span>
                //     <i class="material-icons white-text">
                //         expand_more
                //     </i>
                // </div>
                <Button
                onClick={() => campaignIsPaused(props.data?.campaign_id)}
                style={{
                  background: "#6fcf97",
                  color: "white",
                  borderRadius: "20px",
                  padding: "1px 8px",
                }}
                variant="contained"
                size="small"
                startIcon={
                  
                    msg !== "Running" ? (
                      <PauseIcon />
                    ) : (
                      <PlayArrowIcon />
                    )
                  
                }
                endIcon={<ExpandMoreIcon />}
              >
                {msg}
              </Button>
            )}
            {!isRunning && unsubscribe && !isPaused && (
                <div class="running_btn_campaigns d-flex align-items-center bg-green px-2">
                    <span class="white-text mx-2">{msg}</span>
                </div>
            )}
        </div>
        {
            openPermissionDeniedModal && (
            <PermissionDeniedModal
                    open={openPermissionDeniedModal}
                    onClose={() => setOpenPermissionDeniedModal(false)}
                    message={permissionDeniedMessge}
                />
            )}
        </>
        
    );
}

const mapStateToProps = state => {
    return {

    };
};
const mapDispatchToProps = dispatch => {
    return {
        campaignStart: (params, callback) => dispatch(campaignStart(params, callback)),
        campaignPause: (params, callback) => dispatch(campaignPause(params, callback))
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(Campaign);
